<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<template>
  <div class="card base-icon-card mb-4 h-100">
    <div class="card-body d-flex flex-column">
      <h3 class="card-title mb-4">
        <span class="mr-3"><slot name="icon"></slot></span>
        {{ title }}
      </h3>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.base-icon-card {
  border-radius: 10px;
  svg {
    fill: white;
  }
  .card-body {
    padding: 16px;
  }
  h3 {
    display: flex;
    line-height: 48px;
    span {
      align-items: center;
      background-color: $color-primary;
      border-radius: 12px;
      display: inline-flex;
      height: 48px;
      justify-content: center;
      width: 48px;
    }
  }
}
</style>
